import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import TrustBar from '../../components/feature/TrustBar';
import PlatformPartners from '../../components/feature/PlatformPartners';
import AIAnswerBlock, { AIAnswer } from '../../components/feature/AIAnswerBlock';
import Process, { ProcessStep } from '../../components/feature/Process';
import WhyChooseUs from '../../components/feature/WhyChooseUs';
import ServiceAreas from '../../components/feature/ServiceAreas';
import Testimonials from '../../components/feature/Testimonials';
import FAQ from '../../components/feature/FAQ';
import FinalCTA from '../../components/feature/FinalCTA';
import ServicesHero from './components/Hero';
import ServicesDetailOverview from './components/ServicesOverview';

const servicesAnswers: AIAnswer[] = [
  {
    q: 'What compliance services does ECS provide?',
    a: "ECS manages ISNetworld® account setup, maintenance, and score improvement; Veriforce compliance and documentation; Avetta qualification and ongoing management; RAVS Plus support; TRIR/DART/EMR injury rate reduction; and comprehensive safety training programs including onsite, online, classroom, and tailgate options.",
  },
  {
    q: 'What is RAVS Plus and why does it matter?',
    a: "RAVS Plus is an advanced documentation component of ISNetworld compliance required by many major energy operators. ECS provides specialized RAVS Plus support to ensure your documentation meets operator standards — it's one of the most complex requirements and requires expert handling to complete correctly.",
  },
  {
    q: 'How does ECS manage multiple compliance platforms simultaneously?',
    a: "ECS handles all three major contractor prequalification platforms — ISNetworld, Veriforce, and Avetta. Whether you need one or all three managed, you work with the same dedicated expert who maintains your accounts, tracks requirements, and ensures nothing lapses.",
  },
  {
    q: 'What is included in injury rate reduction services?',
    a: "ECS provides targeted TRIR, DART, and EMR reduction programs that help contractors lower their incident rates, avoid disqualification from operators, and reduce Workers' Compensation insurance costs. We analyze your current rates and implement documentation and program improvements.",
  },
];

const servicesSteps: ProcessStep[] = [
  {
    number: '01',
    title: 'Identify Your Platforms',
    description:
      'We review which platforms you need to be compliant on — ISNetworld, Veriforce, Avetta, or all three — and assess your current account status across each.',
  },
  {
    number: '02',
    title: 'Account Deep Dive',
    description:
      'We analyze your existing accounts in full detail, identifying every gap, deficiency, and opportunity for score improvement. Nothing is overlooked.',
  },
  {
    number: '03',
    title: 'We Handle Everything',
    description:
      'Our experts manage all documentation, safety training records, RAVS Plus requirements, injury rate data, and score optimization. You focus on running your business.',
  },
  {
    number: '04',
    title: 'Maintained at 100%',
    description:
      'Once approved, we maintain your accounts month-to-month — tracking requirements, updating documentation, and ensuring you never lose compliance standing.',
  },
];

export default function Services() {
  return (
    <main>
      {/* 1. Hero */}
      <Navbar />
      <ServicesHero />
      {/* 2. Trust Bar */}
      <TrustBar />
      {/* Platform Showcase */}
      <PlatformPartners />
      {/* 3. Services Overview */}
      <ServicesDetailOverview />
      {/* 4. AI Answer Block */}
      <AIAnswerBlock
        answers={servicesAnswers}
        headline="Every Service, Handled by Specialists"
        subtext="A clear overview of what ECS provides for energy contractors who need ISNetworld, Veriforce, Avetta, and related compliance services managed by experts."
      />
      {/* 5. Process */}
      <Process
        steps={servicesSteps}
        headline="How ECS Handles Your Compliance"
        subheadline="From initial assessment to 100% approval and ongoing maintenance — here's exactly how our service works."
      />
      {/* 6. Why Choose Us */}
      <WhyChooseUs />
      {/* 7. Service Areas */}
      <ServiceAreas />
      {/* 8. Testimonials */}
      <Testimonials />
      {/* 9. FAQ */}
      <FAQ />
      {/* 10. Final CTA */}
      <FinalCTA />
      <Footer />
    </main>
  );
}
